import { reelCredits } from 'fym-shared/src/music24/music24Plans';
import type { AssetStyleId, WaveformShape } from 'fym-shared/src/music24/assetStyles';
import { styleTakesWaveform } from 'fym-shared/src/music24/assetStyles';
import { CreateKitAssetItem } from '../../../../redux/api/fymAPI.types';
import { itemsCredits } from '../studio/studioRules';
import { RevisionEntry } from './revisionModel';

/** The choices of "Make a new revision" (design d3). Absent: keep the value of the revision. */
export interface RevisionChoice {
  style?: AssetStyleId;
  waveform?: WaveformShape;
  /** The lyric line of a type that has one. */
  text?: string;
}

/**
 * The make item of a new kit asset revision: the same type and the params of the revision it
 * starts from, with the choices of the dialog. The theme is the song theme now (the server reads it).
 * Null for a reel revision. Pure.
 */
export function revisionKitItem(entry: RevisionEntry, choice: RevisionChoice): CreateKitAssetItem | null {
  if (entry.asset === null) {
    return null;
  }
  const params = { ...entry.asset.params };
  const style = choice.style ?? params.style;
  if (style !== undefined) {
    params.style = style;
  }
  if (style !== undefined && styleTakesWaveform(entry.asset.themeId, style)) {
    const waveform = choice.waveform ?? params.waveform;
    if (waveform !== undefined) {
      params.waveform = waveform;
    }
  } else {
    delete params.waveform;
  }
  if (choice.text !== undefined && choice.text.trim() !== '') {
    params.lyricLine = choice.text.trim();
  }
  return { themeId: entry.asset.themeId, params };
}

/** The video credits of the new revision: 0 for an image, the reel price for a reel. */
export function revisionCost(entry: RevisionEntry, choice: RevisionChoice): number {
  if (entry.reel !== null) {
    return reelCredits();
  }
  const item = revisionKitItem(entry, choice);
  return item === null ? 0 : itemsCredits([item]);
}
